import { TCountryCode } from "utils/constants/countries.constants";
import AVAREF from "assets/icons/flags/avaref.svg";
import EU from "assets/icons/flags/eu.svg";
import PAHO from "assets/icons/flags/paho.svg";
import WHO from "assets/icons/flags/who.svg";

export const CUSTOM_FLAGS_USED_INSTEAD_OF_COUNTRY_FLAGS: Readonly<
  {
    tenantId: string;
    country: TCountryCode;
    flag: string;
  }[]
> = [
  {
    tenantId: "aa-avaref",
    country: "AA",
    flag: AVAREF,
  },
  {
    tenantId: "ch-who",
    country: "CH",
    flag: WHO,
  },
  {
    tenantId: "us-paho",
    country: "US",
    flag: PAHO,
  },
  {
    tenantId: "de-tuvsud",
    country: "DE",
    flag: EU,
  },
  {
    tenantId: "nl-bsigroup",
    country: "NL",
    flag: EU,
  },
];
